import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { first } from 'rxjs/operators';
import { MatSort } from '@angular/material/sort';
import { CampaignStatus } from 'src/app/models/campaign';
import { CampaignService } from 'src/app/services/campaign.service';
import { PaymentService } from 'src/app/services/payment.service';
import { AlertService } from '../../../shared/alert/alert.service';
import { CampaignPaymentTransactionHistoryModal } from '../campaign-payment-transaction-history-modal/campaign-payment-transaction-history-modal.component';

@Component({
    selector: 'app-transactions-history',
    templateUrl: './transactions-history.component.html',
    styleUrls: ['./transactions-history.component.scss']
})
export class TransactionsHistoryComponent implements OnInit {
    displayedColumns: string[] = [
        'date',
        'campaignName',
        'issuerName',
        'campaignPrice',
        'charges',
        'vat',
        'totalCampaignFees'
    ];

    dataSource;
    transactionDataSource;
    vat;

    alertOptions = {
        autoClose: true,
        keepAfterRouteChange: false
    };
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    constructor(
        public dialog: MatDialog,
        private alertService: AlertService,
        private campaignService: CampaignService,
        private paymentService: PaymentService
    ) { }

    ngOnInit(): void {
        this.getVatValue();
        this.getUserCampaignsList();
    }

    getVatValue() {
        this.paymentService.getVatAmount().subscribe(response => {
            this.vat = response;
        });
    }

    getMfCharges(element) {
        const totalCharge = element.totalCharge;
        if (element.totalMunicipalityFees != 0) {
            return element.totalMunicipalityFees;
        } else {
            return totalCharge;
        }
    }

    getCampaignTotalFees(campaignTotalPriceWithMf, totalCharges) {
        return campaignTotalPriceWithMf != 0.0
            ? campaignTotalPriceWithMf + (campaignTotalPriceWithMf * this.vat) / 100
            : totalCharges;
    }

    getCampaignTransactionHistory(campaignId) {
        this.paymentService.getTransactionHistory(campaignId).subscribe((response: any) => {
            this.transactionDataSource = new MatTableDataSource(response);
            this.transactionDataSource.sort = this.sort;
            this.transactionDataSource.paginator = this.paginator;

            this.showCampaignTransactionHistory(this.transactionDataSource);
        });
    }

    showCampaignTransactionHistory(transactionDataSource) {
        const dialogRef = this.dialog.open(CampaignPaymentTransactionHistoryModal, {
            width: '90%',
            height: 'fit-content',
            data: {
                transactionDataSource,
                columns: ['supplierName', 'transactionType', 'amount', 'createdAt'],
                vat: this.vat
            }
        });
    }

    getUserCampaignsList() {
        this.campaignService
            .getCampaigns({
                status: [
                    CampaignStatus.PENDING_APPROVAL,
                    CampaignStatus.PENDING_REAPPROVAL,
                    CampaignStatus.BEING_EDITED,
                    CampaignStatus.PAUSED,
                    CampaignStatus.PARTIALLY_APPROVED,
                    CampaignStatus.APPROVED,
                    CampaignStatus.CANCELLED,
                    CampaignStatus.STOPPED,
                    CampaignStatus.COMPLETED,
                    CampaignStatus.LIVE,
                    CampaignStatus.PARTIALLY_LIVE,
                    CampaignStatus.REJECTED,
                    CampaignStatus.PARTIALLY_REJECTED
                ],
                startDate: null,
                endDate: null,
                sortDirection: 'desc',
                sortColumn: 'modifiedAt',
                size: 100000,
                page: 0
            })
            .pipe(first())
            .subscribe({
                next: (resp: any) => {
                    this.dataSource = new MatTableDataSource(resp.content);
                    if (this.paginator != undefined) {
                        this.dataSource.paginator = this.paginator;
                        this.paginator.length = resp.totalElements;
                        this.paginator._changePageSize(this.paginator.pageSize);
                    }
                },
                error: error => {
                    this.alertService.error('Error: ' + error, this.alertOptions);
                }
            });
    }
}
